require('Assets/scss/templates/gutenberg-distilled-sounds-template.scss');
